ACDiscountApp.CartPage.Show_CalculateTier = function () {
    var TieredPricingCart = function (cartObject, isUpdate) {
        variantIdsToSend = []; minimumDiscountSubtotal = 0; priceDiff = 0; var updatedTotalPrice = 0; var actualTotalPrice = 0;
        let tierObj = globalFieldsCartPage_AC.cartSubTotalMetafield;
        let tierArr = [];
       if(tierObj != undefined  && tierObj != "[]"){
            for (let ii = 0; ii < tierObj.length ; ii++) {
              if(tierObj[ii].tier.status){
            tierArr.push(tierObj[ii].tier)
                }
          }


        tierArr =  tierArr.sort((a, b) => a.tier_min[0] - b.tier_min[0])
        let Temp = {};
        let tier_maxs = [];
        let tier_mins = [];
        let tier_values_ = [];
         for (let kk = 0; kk < tierArr.length; kk++) {
           if(tierArr[kk].status){
          Temp.discount_type = tierArr[kk].discount_type;
          Temp.end_date = tierArr[kk].end_date;
          Temp.start_date = tierArr[kk].start_date;
          Temp.status = tierArr[kk].status;
          tier_maxs.push(tierArr[kk +1] != undefined ? tierArr[kk +1].tier_min[0] - (0.01) : "max");
          tier_mins.push(tierArr[kk].tier_min[0]);
          tier_values_.push(tierArr[kk].tier_values[0]);
            }
         }
        Temp.tier_max = tier_maxs;
        Temp.tier_min = tier_mins;
        Temp.tier_values = tier_values_;
         debugger
        if (Temp != undefined && Temp != "[]" && Temp.status && globalFields.StartEndDateValid(Temp.start_date, Temp.end_date)) {
          var calculatedTier = CalculateTierCartSubTotal(Temp, globalFieldsCartPage_AC.is_quantity_total, true);
         let TierMinimumamount = calculatedTier[0];
         let TierSecondMaxamount = calculatedTier[1] == "max" ? null :calculatedTier[1] + (1);
        let TierSecondMaxamount__ = calculatedTier[0];
         let TierPercent = calculatedTier[2];
         let TierDiscontedPrice = calculatedTier[5];
         let CartTotallessthenten = (calculatedTier[0] -10);
         let originalCartTotall = calculatedTier[4];
         let EncourageMessage = '';
         let CartMessage = '';
         let DiscountType= '';
         let Max_DiscountPercent = Temp.tier_values[Temp.tier_values.length-1]
          for (let mk = 0; mk < tierObj.length; mk++) {
              if(tierObj[mk].tier.tier_min.includes(TierSecondMaxamount)){
                EncourageMessage = tierObj[mk].tier.tier_name;
              }
              if(tierObj[mk].tier.tier_min.includes(TierMinimumamount)){
                CartMessage = tierObj[mk].tier.tier_name;
                 DiscountType=tierObj[mk].tier.discount_type
              }
          }  
          // Less then minimim tier
          
          jQuery('.cart__row .cart-discount-amount').empty();
           if(tierObj[0].tier.tier_min[0] > originalCartTotall){
             let discountmessage =  localStorage.getItem("acdiscountCodes");
            if(discountmessage != null){
              localStorage.removeItem("acdiscountCodes");
            }
           }
          let T = [];
          
          // for (let mk = 0; mk < Temp.tier_min.length; mk++) {
              
          //   }
          
          if(Temp.tier_min[0]  <=  originalCartTotall && (originalCartTotall < Temp.tier_max[0] || Temp.tier_max[0] == "max" ) ){
            
             
            let MessageCartValueLessthen = tierObj[0].tier.tier_name;
            let First_Discount = `<div class="cart-discount-amount" style=" font-weight: bold; "><span class="order-discount order-discount--title order-discount--cart"><span class="icon icon-saletag" aria-hidden="true"></span><span class="visually-hidden">Discount:</span>${CartMessage}</span></div>`;
            // jQuery('.cart__row .cart-discount-amount').empty();
             jQuery('.cart__subtotal').after(First_Discount);
             let Obj = {message:CartMessage,DiscountAmount:Temp.tier_values[0],DiscountType:Temp.discount_type}
           localStorage.setItem("acdiscountCodes", JSON.stringify(Obj));
            }
            
          else if(  Temp.tier_min[1]  <=   originalCartTotall ){
            let Second_Discount = `<div class="cart-discount-amount" style=" font-weight: bold; "><span class="order-discount order-discount--title order-discount--cart"><span class="icon icon-saletag" aria-hidden="true"></span><span class="visually-hidden">Discount:</span>${CartMessage}</span></div>`;
            // jQuery('.cart__row .cart-discount-amount').empty();
           jQuery('.cart__subtotal').after(Second_Discount);
            let PrevMessaagess = `Congrats you've got ${calculatedTier[2].toFixed(2)}% Off`;
           let Obj = {message:CartMessage,DiscountAmount:calculatedTier[2],DiscountType:DiscountType}
           localStorage.setItem("acdiscountCodes", JSON.stringify(Obj));
           }
           else if(TierSecondMaxamount == null && Temp.tier_min[1]  <=   originalCartTotall && Temp.tier_min[0]  <=  originalCartTotall ){
            let Max_Discount = `<div class="cart-discount-amount" style=" font-weight: bold; "><span class="order-discount order-discount--title order-discount--cart"><span class="icon icon-saletag" aria-hidden="true"></span><span class="visually-hidden">Discount:</span>
           ${CartMessage}</span></div>`;
            // jQuery('.cart__row .cart-discount-amount').empty();
           jQuery('.cart__subtotal').after(Max_Discount);
            let Messaagess = `Congrats you've got ${Max_DiscountPercent.toFixed(2)}% Off`;
            let Objs = {message:CartMessage,DiscountAmount:calculatedTier[2]}
             
            localStorage.setItem("acdiscountCodes", JSON.stringify(Objs));
          }
           else{
             localStorage.removeItem("acdiscountCodes");
          }
    }else{
          localStorage.removeItem("acdiscountCodes");
    }
      }else{
           localStorage.removeItem("acdiscountCodes");
      }
    }


    var CalculateTierCartSubTotal = function (tiers, is_quantity_total, isNotInRange) {
        var eligibleItems = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return !n.is_exclude; });
        var allVariantItemQty = 0;
        var eligibleSubtotal = 0;
        var discount_total = 0;
        // for (j = 0; j < eligibleItems.length; j++) {
        //     allVariantItemQty += eligibleItems[j].item.quantity;
        //     eligibleSubtotal += globalFields.ConvertToFixedDecimalNumber(eligibleItems[j].item.original_line_price / 100);
        //    console.log(eligibleSubtotal)
        // }
      
       
        let Cart_Total_Price = jQuery('.cart__subtotal .bcapp-cart-total')[0].innerText;
    if(Cart_Total_Price == ''){
       Cart_Total_Price = jQuery('.cart__subtotal .h5.cart__subtotal-price')[0].innerText;
    }
        let Remove_Cart_Dollar = Cart_Total_Price.split('$');
        let CartpriceIntegerValue = Remove_Cart_Dollar[1].replace(/\,/g,'');
        let CartTotalPrice= Number(CartpriceIntegerValue);
      eligibleSubtotal = parseInt(CartTotalPrice)
        var tierPrice = 0, minTier = 0, maxTier = '';
        for (i = 0; i < tiers.tier_min.length; i++) {
            tierPrice = parseFloat(tiers.tier_values[i]);
            minTier = parseInt(tiers.tier_min[i]), maxTier = tiers.tier_max[i] != 'max' ? parseInt(tiers.tier_max[i]) : tiers.tier_max[i];
            var condition1 = false, condition2 = false;
            if (is_quantity_total) {
                condition1 = allVariantItemQty >= minTier;
                condition2 = maxTier == "max" || allVariantItemQty <= maxTier;
            } else {
                condition1 = eligibleSubtotal >= minTier;
                condition2 = maxTier == "max" || eligibleSubtotal <= maxTier;
            }

            if (condition1 && condition2) {
                isNotInRange = false;
                if (tiers.discount_type == 'percentage') {
                    discount_total = parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFields.ConvertToFixedDecimalNumber(eligibleSubtotal)));
                }
                else if (tiers.discount_type == 'fixed') {
                    discount_total = globalFields.ConvertToFixedDecimalNumber(parseFloat(tierPrice));
                }
                break;
            }
        }
        return [minTier, maxTier, tierPrice, isNotInRange, eligibleSubtotal, discount_total];
    }

    
    var FetchCartTiers = function () {
        jQuery.ajax({
            async: false,
            url: "/cart/?view=ac_cart_subtotal_tiers",
            success: function (result) {
                globalFieldsCartPage_AC.cartTiersArray = JSON.parse(result);
                TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
                 // CheckoutClickCart(); CheckoutClickAjax();
            },
            error: function (e) { console.log(e.statusText); }
        });
    }
    /*
        var open = window.XMLHttpRequest.prototype.open, send = window.XMLHttpRequest.prototype.send, onReadyStateChange;
        function openReplacement(method, url, async, user, password) { return open.apply(this, arguments); }
        function sendReplacement(data) {
            this.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    ProcessCartResponse(this._url, this.responseText);
                }
            };
            return send.apply(this, arguments);
        }
        window.XMLHttpRequest.prototype.open = openReplacement; window.XMLHttpRequest.prototype.send = sendReplacement;
    */
    jQuery(document).ajaxComplete(function (event, xhr, settings) {
        ProcessCartResponse(settings.url, xhr.responseText);
    });

  var ProcessCartResponse = function (splittedUrl, responseText) {
        if (splittedUrl != 'undefined' && splittedUrl != "" && splittedUrl != null) {
            splittedUrl = splittedUrl.split("?");
            if (splittedUrl[0] == "/cart.js" || splittedUrl[0] == "/cart/change.js") {
                globalFieldsCartPage_AC.cartObj = JSON.parse(responseText);
                setTimeout(function () {
                    FetchCartTiers();
                }, 500);
            }
        }
    }
  
    try {
        var nativeFetch = window.fetch;
        window.fetch = function (...args) {
                console.log('detected fetch call');
                console.log(args[0]);
           
            if (args[0].includes("/cart/change") || args[0].includes("/cart/update.js") || args[0].includes("/add.js")) {
                setTimeout(function () {
                    fetch('/cart.js')
                        .then(r => r.json().then(data => ({ status: r.status, body: data })))
                        .then(obj => ProcessCartResponse("/cart.js", JSON.stringify(obj.body)));
                }, 500);
            }
            return nativeFetch.apply(window, args);
        }
    }
    catch (e) { }

    // var SetCookie = function (cname, cvalue, exdays) { var d = new Date(); d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); var expires = "expires=" + d.toUTCString(); document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; }
   setTimeout(function () {
   TieredPricingCart(globalFieldsCartPage_AC.cartObj, true); 
    }, 1500);

 
  
}

var globalFieldsCartPage_AC = new ACDiscountApp.CartPage.Global(); var cartObject = new ACDiscountApp.CartPage.Show_CalculateTier();